import { trpc } from "../trpc";

export const useCanvas = (canvasId: string | undefined, options?: any) => {
  const { data, isError, isLoading } = trpc.canvas.get.useQuery(
    { id: canvasId || "" },
    {
      enabled: !!canvasId,
      ...options,
    },
  );

  return {
    data,
    isError,
    isLoading,
  };
};
